import { render } from "./GuardianColumnsSelect.vue?vue&type=template&id=4ce60962&scoped=true&ts=true"
import script from "./GuardianColumnsSelect.vue?vue&type=script&lang=ts"
export * from "./GuardianColumnsSelect.vue?vue&type=script&lang=ts"

import "./GuardianColumnsSelect.vue?vue&type=style&index=0&id=4ce60962&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce60962"]])

export default __exports__